import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { formatSiteWithLogo, getSection } from "app/utils"
import { PARITY_URL } from 'app/@common/constants'


export default function SelectSite({ source, ...props }) {

    const section = getSection(window.location.href)

    if ((section === 'parity' || section === 'notifications') && !props.date) return <SelectLoading />
    if (section === 'notifications' && !props.alertType) return <SelectLoading />

    const myProps = {
        urlAjax: PARITY_URL.SITES,
        placeholder: 'All sites',
        isClearable: true, 
        isMulti: true,
        icon: { icon: 'browser' },
        formatOptionLabel: ({ label }) => formatSiteWithLogo({ siteName: label.toLowerCase() }),
        extraParams: {
            ...props.excludeSiteID && { excludeSiteID: props.excludeSiteID },
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.date && { dateRange: props.date },
            ...props.userID && { userID: props.userID },
            ...props.alertType && { tp: props.alertType },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            },
            ...props.market && { market: props.market },
        },
        limitedChips: true,
        numberOfChips: 4,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}